import React from 'react'
import { Grid, Icon, Segment, Tab, Table } from 'semantic-ui-react'
import { Redirect } from 'react-router-dom'

import moment from 'moment'
import titleCase from 'title-case'

import './Teacher.css'

const changeCase = {
    titleCase: titleCase
}

const TeacherPV = (props) => {
  if (props.auth) {
    if (props.userType === 'admin' || props.userType === 'principal' || props.userType === 'registrar') {
    const panes = [
      { menuItem: 'Demographics', render: () =>
        <Tab.Pane>
          <Table basic='very' celled size='small'>
            <Table.Body>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Name</strong>
                </Table.Cell>
                <Table.Cell><span>{props.teacher.lastName}, {props.teacher.firstName} {props.middleName}</span></Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Gender</strong>
                </Table.Cell>
                <Table.Cell>{props.teacher.gender}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Birthdate</strong>
                </Table.Cell>
                <Table.Cell>{moment(props.teacher.birthDate).format('MMM DD, YYYY')}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Tab.Pane> },
      { menuItem: 'Contact Information', render: () =>
        <Tab.Pane>
          <Table basic='very' celled size='small'>
            <Table.Body>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Address</strong>
                </Table.Cell>
                <Table.Cell>{props.teacher.address}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Contact Number</strong>
                </Table.Cell>
                <Table.Cell>{props.teacher.contactNumber}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Email</strong>
                </Table.Cell>
                <Table.Cell>{props.teacher.email}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Tab.Pane> },
      { menuItem: 'Employment Information', render: () =>
        <Tab.Pane>
          <Table basic='very' celled size='small'>
            <Table.Body>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Employment Type</strong>
                </Table.Cell>
                <Table.Cell>{props.teacher.employmentType}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Degree Earned</strong>
                </Table.Cell>
                <Table.Cell>{props.teacher.degreeEarned}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Years of Teaching</strong>
                </Table.Cell>
                <Table.Cell>{props.teacher.yearsOfTeaching}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Years of Teaching in SALIS</strong>
                </Table.Cell>
                <Table.Cell>{props.teacher.yearsOfTeachingSALIS}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Tab.Pane> },
        { menuItem: 'System Information', render: () =>
          <Tab.Pane>
            <Table basic='very' celled size='small'>
              <Table.Body>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Username</strong>
                  </Table.Cell>
                  <Table.Cell>{props.teacher.username}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Password</strong>
                  </Table.Cell>
                  <Table.Cell>Password is not shown for security reasons. Ask the system administrator if you forgot your password.</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>User Type</strong>
                  </Table.Cell>
                  <Table.Cell>{changeCase.titleCase(props.teacher.type)}</Table.Cell>
                </Table.Row>
                {
                  props.teacher.type === 'levelHead'?
                  <Table.Row>
                    <Table.Cell collapsing>
                      <strong>Level Type</strong>
                    </Table.Cell>
                    <Table.Cell>{props.teacher.level}</Table.Cell>
                  </Table.Row> :
                  null
                }
              </Table.Body>
            </Table>
          </Tab.Pane> },
      { menuItem: 'Classes', render: () => <Tab.Pane>Under Development</Tab.Pane> }
    ]
    return (
        <Grid centered>
          <Grid.Row className='teacher-back-grid-row'>
            <Grid.Column width={16}>
              <span className='menu-text' onClick={() => props.goBack()}>
                <Icon name='arrow left' />Back to List
              </span>
                <Icon className='menu-icon' name='times'
                  style={{float:'right'}} onClick={() => props.goBack()}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <Segment>
              <div className='teacher-name-div'>
                <Icon name='user' size='large'/>
                <span className='teacher-name'>{props.teacher.lastName}, {props.teacher.firstName}</span>
              </div>
              <Tab panes={panes} />
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
    )
  } else {
    return <Segment>You are not authorized to be in this page.</Segment>
  }
  } else {
    return <Redirect to='/' />
  }

}

export default TeacherPV;
